<template>
  <div class="check-in">
    <payDialog
      title="修护登记确认"
      :bizType="'pay'"
      :hide="dialogHide"
      :mobile="form.mobile"
      @changeDialog="savePay"
    ></payDialog>
    <el-dialog
      class="search-dialog"
      :visible.sync="memberSearchHide"
      width="450px"
      style="z-index:9999;"
      title="选择会员"
      center
      :before-close="dialogclose"
    >
      <div class="p10">
        <el-input
          placeholder="输入客户手机号、编号或姓名"
          v-model="memberMsg"
          clearable
          @clear="clearMember"
          class="input-with-select"
          prefix-icon="el-icon-search"
          
        >
          <el-button type="primary" slot="append" @click="selectMember">搜索会员</el-button>
        </el-input>
        <div class="member-box" v-if="memberHide">
          <div class="list" v-if="list">
            <div class="flex-row p10" @click="clickMember(list)">
              <el-avatar :src="list.headImgUrl" v-if="list.headImgUrl"></el-avatar>
              <el-avatar :src="headImg" v-else></el-avatar>
              <div class="msg ml10">
                <p>{{ list.mobile }} ({{ list.nickName }})</p>
                <p>账户余额: {{ list.walletAmount }}</p>
              </div>
            </div>
          </div>
          <div class v-else>没有此会员信息</div>
        </div>
        <div class="mt10 memberMsg" v-if="memberMsgHide">
          <div class="space-between m10">
            <p>姓名</p>
            <p>{{ list.nickName }}</p>
          </div>
          <div class="space-between m10">
            <p>手机号码</p>
            <p>{{ list.mobile }}</p>
          </div>
          <div class="space-between m10">
            <p>修护卡编号</p>
            <p>{{ form.docNo }}</p>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" v-if="memberMsgHide">
        <el-button @click="dialogclose">取 消</el-button>
        <el-button type="primary" @click="dialogconfig">确 定</el-button>
      </span>
    </el-dialog>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="pay-mains">
          <div class="totals-box plr24 mt20">
            <div class="flex-row mb30">
              <div class="itemName">顾客姓名</div>
              <div>{{ form.customerName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">顾客手机号</div>
              <div>{{ form.mobile }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">建档门店</div>
              <div>{{ form.shopIdCn }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">建档技师</div>
              <div>{{ form.staffIdCn }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">来源</div>
              <div>{{ form.repairOriginCn }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">档案金额</div>
              <div>{{ form.shopId == userInfo.shopId ? '￥'+ form.amount: '****' }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">卡券优惠</div>
              <div>{{ form.couponAmount ? '￥'+ form.couponAmount: '¥ 0' }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">已收金额</div>
              <div>{{ form.shopId == userInfo.shopId ? '￥'+ form.realPayAmount: '****' }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">已收款次数</div>
              <div>{{ form.repairPayRecordSize }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">分类</div>
              <div>{{ form.categoryName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">部位及个数</div>
              <div>{{ form.symptom }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">原始备注 <el-popover
                    v-model="popFlag"
                    placement="right"
                    width="400"
                    trigger="click"
                    @hide="remakHide"
                    v-if="form.repairStatus == 'build' || form.repairStatus == 'handle'">
                        <el-input v-model="remark" type="textarea" :maxlength="150"></el-input>
                        <el-button type="primary" style="margin-top: 10px;width: 100%;" size="mini" @click="updateRemark">确定</el-button>
                    <span slot="reference" class="el-icon-edit-outline jishi cur"></span>
                    </el-popover></div>
              <div>{{ form.remark }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">档案状态</div>
              <div class="jishi">{{ form.repairStatusCn }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">登记次数</div>
              <div class="jishi">{{ form.registrationNumber }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">档案编号</div>
              <div>{{ form.docNo }}</div>
            </div>
            <div class="flex-row mb30" v-if="isNeedSms">
              <div class="itemName">验证号码</div>
              <div>{{ form.validMobile }}</div>
            </div>
            <div class="flex-row mb30" v-if="form.repairOrigin != 'merchantapp'">
              <div class="itemName">会员卡绑定状态</div>
              <div class="active" v-if="form.repairOrigin == 'paper' && form.memberId == null">未绑定</div>
              <div class="active" v-else>已绑定</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">建档时间</div>
              <div>{{ formatDate(form.recordTime) }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">付款顾客</div>
              <div>{{ form.payMemberName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">付款手机号</div>
              <div>{{ form.payMemberMobile }}</div>
            </div>
            <div class="flex-row mb30" v-if="form.repairStatus == 'finish'">
              <div class="itemName">完成时间</div>
              <div>{{ formatDay(form.oxLtime) }}</div>
            </div>
            <div class="flex-row mb30" v-if="form.repairStatus != 'finish'">
              <div class="itemName">下次登记时间</div>
              <div>{{ formatDay(form.nextRepairTime) }}</div>
            </div>
            <div class="flex-row mb30" v-if="form.repairStatus != 'finish' && form.repairStatus != 'build'">
              <div class="itemName">过期时间</div>
              <div>{{ form.validDay == -1?'永久有效':formatDay(form.validEndTime) }}</div>
            </div>
          </div>
          <div v-if="form.repairPayRecordList && form.repairPayRecordList.length != 0">
            <p class="order-title-boxs"><span class="blueBlock"></span><i>收款记录</i></p>
            <div class="detail plr20">
              <el-table :data="form.repairPayRecordList" input-large header-cell-class-name="table_header_bgcolor">
                <el-table-column label="操作时间" width="180px">
                  <template slot-scope="scope">{{ formatDate(scope.row.oxCtime)}}</template>
                </el-table-column>
                <el-table-column prop="staffName" label=" 服务技师" width="auto"></el-table-column>
                <el-table-column prop="amount" label="收款金额" width="auto" align="right"></el-table-column>
            
              </el-table>
            </div>
          </div>
          <div v-if="refundList.length != 0">
            <p class="order-title-boxs" ><span class="blueBlock"></span><i>退款明细</i></p>
            <div class="totals-box mlr24">
              <el-row class="order-details">
                <el-col :span="10" class="pl10">商品名称</el-col>
                <el-col :span="3">数量</el-col>
                <el-col :span="4">退款</el-col>
                <el-col :span="4">社保补贴</el-col>
                <el-col :span="3" class="tRight pr10">扣除</el-col>
              </el-row>
              <el-row v-for="(item,index) in refundList" :key="index" class="mt20">
                <el-col :span="4" class="pl10 mb20 color999">审核状态</el-col>
                <el-col :span="20" class="mb20 tRight pr10">
                  <div :class="item.auditStatus == 'pass' || item.auditStatus == 'wait' ? 'jishi': 'moneys'">{{item.auditStatusCn}}</div>
                </el-col>
                <el-col :span="10" class="pl10">{{item.itemName}}</el-col>
                <el-col :span="3" class="color999">{{item.itemNum}}</el-col>
                <el-col :span="4" class="color999">{{item.refundAmount}}</el-col>
                <el-col :span="4" class="color999">{{item.socialSubsidyAmount}}</el-col>
                <el-col :span="3" class="tRight pr10">{{item.deductAmount}}</el-col>
                <el-col :span="4" class="pl10 mt20 color999">技师</el-col>
                <el-col :span="20" class="mt20 tRight pr10">
                    <div class="jishi">{{item.staffNames}}</div>
                </el-col>
              </el-row>
            </div>
          </div>
            
          <div class="repair-box">
            <div>
              <div v-for="(item,index) in form.recordList" :key="index" class="totals-box  mt20">
                <div class="top pr24">
                  <p class="order-title-boxs" ><span class="blueBlock"></span><i>{{formatDate(item.repairTime)}}</i></p>
                  <p
                    :class="item.auditStatus == 'refuse' ? 'moneys':'jishi'"
                  >{{ item.auditStatusCn }}</p>
                </div>
                <div class="flex-row mb30 pl24">
                  <p class="itemName">门店名称</p>
                  <p>{{ item.shopIdCn }}</p>
                </div>
                <div class="flex-row mb30 pl24">
                  <p class="itemName">备注信息</p>
                  <p>{{ item.remark }}</p>
                </div>
                <div class="flex-row mb30 pl24">
                  <p class="itemName">技师</p>
                  <p>{{ item.staffIdCn }}</p>
                </div>
                <div class="center-mains">
                  <div class="imgs">
                    <div class="space-between">
                      <p class="imgs-name">登记照片</p>
                      <p class="cur jishi" v-if="item.thisShopFlag && item.auditStatus != 'pass'" @click="updateRepair(item)">修改</p>
                    </div>
                    <div class="img-list">
                      <el-image
                        class="img"
                        v-for="(i,j) in item.imgUrlList"
                        :key="j"
                        :src="i"
                        title="点击放大图片"
                        :preview-src-list="previewList"
                        @click="handPreview(i)"
                      ></el-image>
                    </div>
                  </div>
                </div>
                <div class="center-mains" v-if="item.signImgUrl">
                  <div class="imgs">
                    <div class="space-between">
                      <p class="imgs-name">签名照片</p>
                    </div>
                    <div class="img-list">
                      <el-image
                        class="img"
                        :src="item.signImgUrl"
                        title="点击放大图片"
                        :preview-src-list="previewList"
                        @click="handPreview(item.signImgUrl)"
                      ></el-image>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="drawer-footer">
          <div class="btns pb10 pr16">
            <el-button type="primary" @click="bandMemberCard" v-if="form.repairOrigin == 'paper' && form.memberId == null">绑定会员卡</el-button>
            <el-button type="success" @click="continuePay" v-if="form.payPeriodFlag">继续支付</el-button>
            <el-button class="btn-dandu" @click="refundClick(form)" v-if="form.refundFlag">申请退款</el-button>
            <el-button type="primary" @click="saveMoney" v-if="form.newDocAddFlag || form.oldDocAddFlag">档案登记</el-button>
          </div>
        </div>
      </div>
    </drawer>
    <staff-set ref="staffSetForm" @staffChange="changePage"></staff-set>
    <handle-edit ref="handleEditForm" @change="editChange"></handle-edit>
    <refund-set ref="editSetForm" @change="handleChange"></refund-set>
    <!-- 继续支付 -->
    <continue-pay ref="payForm" @change="handlePayChange"></continue-pay> 
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
import member from "../../components/member";
import payDialog from "../../components/pay-dialog";
import staffSet from "../../components/staff-set";
import handleEdit from "./handle-edit";
import refundSet from "./refund-set";
import continuePay from "./continuePay.vue";
export default {
  mixins: [minxin],
  components: {
    member,
    payDialog,
    staffSet,
    drawer,
    handleEdit,
    refundSet,
    continuePay
  },
  data() {
    return {
      addEditTitle: "档案详情",
      addEditShow: false,
      dialogHide: false,
      memberSearchHide: false,
      isPayWayHide: true,
      form: {
        recordList: [],
        repairPayRecordList: []
      },
      refundList: [],
      status: 1,
      repairForm: {
        imgUrlList: [],
        remark: "",
        staffId: "",
        repairDocumentId: "",
        nextRepairTime: "" //new Date(),//下次修护时间
      },
      staffNames: "",
      options: [],
      memberMsg: "",
      memberHide: false,
      list: {},
      popFlag: false,
      memberMsgHide: false,
      shopImg: require("../../../assets/images/shop.png"),
      queryId: "",
      headImg: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      remark: "",
      userInfo: {},
      previewList: [],
      isNeedSms: false
    };
  },
  created() {
    // this.handleInit();
  },
  mounted() {
    this.handleInit();
  },
  methods: {
    editChange(org) {
      console.log(this.queryId,"ssss");
      this.getList();
    },
    refundClick(row) {
      this.$refs["editSetForm"].$emit("set", row);
    },
    handleChange(bool) {
      this.addEditShow = false;
    },
    handPreview (url) {
      let imgUrl = []
      this.previewList = []
      if (url.indexOf("?") > -1) {
        let arr = url.split("?")
        imgUrl.push(arr[0])
      } else {
        imgUrl.push(url)
      }
      this.previewList = imgUrl
      console.log(this.previewList);
    },
    handleInit() {
      this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data());
        console.log(org);
        this.addEditShow = true;
        this.queryId = org.id;
        this.userInfo = this.$store.getters.ShopInfo;
        if (sessionStorage.getItem('appInit')) {
          let appInit = JSON.parse(sessionStorage.getItem('appInit'))
          this.isNeedSms = appInit?.configManagerVo?.documentRegister?.verificationCodeFlag ?? false
        }
        this.getList();
      });
    },
    getList() {
        this.$api.get(this.$url.repairDocument.get, {
            id: this.queryId
          }).then(res => {
            if (res) {
              this.form = res;
              this.remark = JSON.parse(JSON.stringify(this.form.remark));
              this.repairForm.repairDocumentId = this.form.id;
              this.listRefundItem(this.form)
              // this.form.memberId = null;
            }
          });
    },
    listRefundItem (form) {
      this.$api.get(this.$url.companyRefund.listRefundItemByRepairId, {repairDocId: form.id}).then(ret => {
        if (ret) {
          this.refundList = ret
        }
      });
    },
    handleChangeDrawer() {
      this.addEditShow = false;
      this.$emit("change", true);
    },
    setStaff(row, index) {
      this.$refs["staffSetForm"].$emit("set", {
        single: true,
        staffIds: this.repairForm.staffId,
        index: 0
      });
    },
    changePage(org) {
      this.repairForm.staffId = org.staffIds[0].staffId;
      this.staffNames = org.staffIds[0].staffName;
    },
    gotoCenter() {
      this.$router.push("/collectMoney/center");
    },
    clearMember() {
      this.memberMsg = "";
      this.list = {};
      this.memberHide = false;
      this.memberMsgHide = false;
    },
    clickMember(list) {
      this.memberHide = false;
      this.memberMsgHide = true;
    },
    dialogclose() {
      this.memberMsg = "";
      this.memberMsgHide = false;
      this.memberSearchHide = false;
      this.list = {};
    },
    dialogconfig() {
      this.$api.get(this.$url.repairDocument.bindMember, {
          docId: this.form.id,
          memberId: this.list.id
        })
        .then(res => {
          if (res) {
            this.memberSearchHide = false;

            this.$api.get(this.$url.repairDocument.get, {
                id: this.queryId
              }).then(res => {
                if (res) {
                  this.form = res;
                  this.repairForm.repairDocumentId = this.form.id;
                }
              });
          }
        })
        .catch(error => {});
    },
    selectMember() {
      if (this.memberMsg != "") {
        this.$api
          .get(this.$url.member.search, {
            keyword: this.memberMsg,
            needIntegralFlag: true
          })
          .then(res => {
            if (res) {
              this.list = res.memberList[0];
              this.memberHide = true;
            } else {
              this.memberHide = false;
              this.$message.warning("没有找到此会员信息");
            }
          })
          .catch(error => {});
      } else {
        this.$message.warning("请输入客户手机号、编号或姓名");
      }
    },
    getFile(res) {
      this.repairForm.imgUrlList.push(res);
    },
    handleDelete(res) {
      this.repairForm.imgUrlList = res;
    },
    memberChange(value) {
      this.repairForm.memberId = value;
    },
    anewSubmit(item) {
      item.nextRepairTime = new Date(this.formatDay(item.repairTime));
      this.staffNames = item.staffIdCn;
      this.repairForm = item;
      this.$refs["handleEditForm"].$emit("set", this.repairForm);
    },
    saveMoney() {
      this.repairForm = {
        imgUrlList: [],
        remark: "",
        staffId: "",
        repairDocumentId: this.queryId,
        nextRepairTime: "",
        categoryId: this.form.categoryId,
        memberId: this.form.memberId
      };
      this.$refs["handleEditForm"].$emit("set", {
        newOrOld: this.form.newDocAddFlag,
        finishRepairFlag: this.form.finishRepairFlag,
        payPeriodFlag: this.form.payPeriodFlag,
        mobile: this.form.mobile,
        categoryName: this.form.categoryName,
        symptom: this.form.symptom,
        newDocumentFlag: this.form.repairOrigin,
        repairForm: this.repairForm
      });
    },
    updateRepair (item) {
      console.log(this.form,"ś222222");
      let a = JSON.parse(JSON.stringify(item.imgUrlList));
      this.repairForm = {
        imgUrlList: a,
        remark: item.remark,
        staffId: item.staffId,
        staffName: item.staffName,
        repairDocumentId: this.queryId,
        nextRepairTime: item.repairTime,
        categoryId: this.form.categoryId,
        memberId: this.form.memberId,
        id: item.id,
        repairStatusCn: this.form.repairStatusCn,
        updateFlag: true
      };
      this.$refs["handleEditForm"].$emit("set", {
        newOrOld: this.form.newDocAddFlag,
        payPeriodFlag: this.form.payPeriodFlag,
        mobile: this.form.mobile,
        categoryName: this.form.categoryName,
        symptom: this.form.symptom,
        newDocumentFlag: this.form.repairOrigin,
        
        repairForm: this.repairForm
      });
    },
    savePay(value) {
      if (value != "") {
        this.repairForm.payCheckType = value.payCheckType;
        this.repairForm.verifyCode = value.verifyCode;
        this.$api
          .post(this.$url.repairRecord.save, this.repairForm)
          .then(res => {
            if (res) {
              this.dialogHide = false;
              this.$router.push({
                path: `/collectMoney/paperRepair/pay`,
                query: {
                  id: this.form.id,
                  repairStatus: this.form.repairStatus
                }
              });
            }
          });
      } else {
        this.dialogHide = false;
      }
    },
    bandMemberCard() {
      this.memberSearchHide = true;
    },
    // 修改 备注
    updateRemark () {
        // this.getList();
        if (!this.remark) return this.$message.error("原始备注不能为空");
         this.$api.get(this.$url.repairDocument.updateRemark, {id: this.form.id, remark: this.remark}).then(res => {
             if (res) {
                 this.$message.success("修改成功")
                this.getList();
                this.popFlag = false;
             }
         })
    },
    remakHide (val) {
        this.remark = JSON.parse(JSON.stringify(this.form.remark));
    },
    continuePay (row) {
        //  继续支付
        this.$refs["payForm"].$emit("set", {
            id: this.repairForm.repairDocumentId,
            memberId: this.form.payMemberId
        })
    },
    handlePayChange () {
        this.getList();
    },
    skipSendSms () {
      sessionStorage.setItem("sendSms", JSON.stringify({id: this.form.memberId, mobile: this.form.mobile, realName: this.form.customerName}))
      this.$router.push('/dataList/smsTemplate');
      this.$store.commit("setCurentPage", 'data');
      localStorage.setItem("setCurentUrl", '/dataList/smsTemplate');
    }
  }
};
</script>

 <style scoped lang="less">
 /deep/ .el-dialog__body {
   height: 200px;
   font-size: 16px !important;
 }
 /deep/ .el-dialog__footer {
   text-align: center;
 }
</style>
<style lang="less" scoped>
@import "../../../assets/css/edit.less";
.pay-mains {
  .titles-head {
    border-top: 0;
  }
  .relatives {
    position: relative;
  }

  .sendSmsIcon {
    position: absolute;
    right: 16px;
    width: 30px;
    height: 30px;
    vertical-align: middle;
  }
  .totals-box {
    .boxs {
      margin-top: 10px;
      background: #fff;
      .rows {
        padding: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid @borderColor;
        p {
          color: #383838;
        }
        .money {
          color: @money;
        }
        .name {
          width: 120px;
          font-size: 16px;
          font-weight: 500;
        }
      }
    }
    .shop-boxs {
      margin-top: 0;
    }
  }
  .repair-box {
    background: #fff;
    .top_box {
          div  {
            width: 33%;
          }
          .box-center {
              text-align: center;
          }
          .box-right {
              text-align: right;
          }
      }
    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 16px;
      .name {
        display: flex;
      }
      .shop-img {
        width: 27px;
        margin-right: 10px;
      }
      .status {
        color: @blue;
      }
    }
    .center-mains {
      color: #666;
      .imgs-name {
        padding: 0 0 20px;
        display: flex;
        font-weight: 500;
        align-items: center;
      }
      .imgs {
        padding: 0 24px 20px;
        .img-list {
          
        }
        .img {
          border-radius: 5px;
          margin: 0 10px 10px 0;
          width: 80px;
          height: 80px;
        }
      }
      .remarks-box {
        padding: 0 20px;
        .remark {
          min-height: 60px;
          display: flex;
          align-items: center;
        }
        .text-area {
          margin-top: 7px;
          margin-bottom: 20px;
          /deep/ .el-textarea__inner {
            height: 76px;
          }
        }
      }
    }
  }
}

/deep/ .el-input-group__append {
  background-color: #409eff;
  color: #fff;
}
/deep/ .input-with-select .el-input__inner {
  height: 56px !important;
}
/deep/ .input-with-select {
  font-size: 16px;
}
// .isMember {
//   // margin-bottom: .2rem;
//   position: relative;
//   .member-header {
//     display: flex;
//     align-items: center;
//     width: 100%;
//     .title-name {
//       font-size: 20px;
//       font-weight: bold;
//       color: #333;
//       margin-right: 62px;
//     }
//     .icon-search {
//       font-size: 0.3rem;
//     }
//   }
// }
.member-box {
  width: calc(100% - 40px);
  height: 120px;
  position: absolute;
  top: 138px;
  left: 20px;
  z-index: 99;
  background: #fff;
  // box-shadow: 1px 1px 5px #bbb;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  .no-result {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: #646566;
    height: 120px;
    p {
      margin-bottom: 10px;
    }
    .bind-member-active {
      margin-top: 10px;
      color: #409eff;
      cursor: pointer;
    }
  }
  .history-box {
    padding: 10px;
  }
  .history-btn {
    margin-top: 10px;
    margin-left: 30px;
  }
}
.list {
  .flex-row {
    cursor: pointer;
    height: 60px;
    display: flex;
    align-items: center;
    padding: 0 10px;
    .msg {
      margin-left: 10px;
    }
    &:hover {
      background-color: #f1f1f1;
    }
  }
}
.member_bg {
  width: 100%;
  height: 56px;
  background-image: url("../../../assets/images/money/member_bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 10px;
  .flex-row {
    align-items: center;
    .img {
      width: 30px;
      height: 30px;
    }
  }
  .icons {
    margin-right: 10px;
    font-size: 18px;
    cursor: pointer;
    &:hover {
      color: @blue;
    }
  }
}
.order-details {
  height: 56px;
  line-height: 56px;
  background: #F7F8FA;
}

</style>
